import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { marketplaceApi } from "../api/client";
import MarketplaceHeader from "../components/MarketplaceHeader";
import ProductCard from "../components/ProductCard";
import FloatingTools from "../components/FloatingTools";
import Footer from "../components/Footer";

function sellerLabel(seller) {
  return seller?.store_name || seller?.business_name || seller?.user_name || "Verified seller";
}

export default function PublicSellers() {
  const [sellers, setSellers] = useState([]);
  const [products, setProducts] = useState([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    marketplaceApi.home()
      .then((res) => {
        if (!mounted) return;
        setSellers(res.data?.sellers || []);
        setProducts(res.data?.products || []);
      })
      .finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, []);

  const filteredSellers = useMemo(() => {
    const clean = query.trim().toLowerCase();
    if (!clean) return sellers;
    return sellers.filter((seller) => `${sellerLabel(seller)} ${seller.city || ""} ${seller.province || ""} ${seller.business_category || ""}`.toLowerCase().includes(clean));
  }, [query, sellers]);

  return (
    <div className="page-shell marketplace-page public-sellers-page" id="top">
      <MarketplaceHeader apiOnline />
      <main className="container public-directory-shell">
        <section className="marketplace-title-banner marketplace-title-banner--sellers">
          <img src="/images/tazy-marketplace-banner-new.webp" alt="" />
          <div className="marketplace-title-banner__content">
            <span>VERIFIED SELLERS</span>
            <h1>Browse trusted storefronts on TAZY CART.</h1>
            <p>Find approved sellers, see their location and open product listings connected to their storefront.</p>
            <form className="marketplace-title-search" onSubmit={(event) => event.preventDefault()}>
              <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search seller, city or category" />
              <button type="button">Search</button>
            </form>
          </div>
        </section>

        <section className="public-directory-grid seller-directory-grid-v2">
          {filteredSellers.length ? filteredSellers.map((seller) => (
            <article className="seller-directory-card seller-directory-card-v2" key={seller.id}>
              <div className="seller-directory-avatar">{seller.logo_src ? <img src={seller.logo_src} alt={sellerLabel(seller)} /> : <span>{sellerLabel(seller).slice(0, 2).toUpperCase()}</span>}</div>
              <div>
                <strong>{sellerLabel(seller)}</strong>
                <small>{seller.city || seller.province || "Zimbabwe"} • Verified seller</small>
                <p>{seller.description || "Marketplace seller with approved profile and active participation on TAZY CART."}</p>
              </div>
              <div className="seller-directory-actions">
                <Link to={`/search?q=${encodeURIComponent(sellerLabel(seller))}&tab=Products`}>View products</Link>
                <Link to="/request">Send sourcing request</Link>
              </div>
            </article>
          )) : <div className="marketplace-empty-feed">{loading ? "Loading verified sellers..." : "No verified sellers available yet."}</div>}
        </section>

        <section className="products-section products-section--compact seller-products-strip">
          <div className="section-heading"><div><h2>Seller products moving now</h2><p>Live products listed by verified marketplace sellers.</p></div><Link to="/search?tab=Products">View all</Link></div>
          <div className="product-grid product-grid--compact">
            {products.slice(0, 8).map((product) => <ProductCard key={product.id} item={product} />)}
            {!products.length ? <div className="marketplace-empty-feed">No seller products are public yet.</div> : null}
          </div>
        </section>
      </main>
      <Footer />
      <FloatingTools />
    </div>
  );
}
